import { render, staticRenderFns } from "./ContestAdwardSectionComponent.vue?vue&type=template&id=77fd3986"
import script from "./ContestAdwardSectionComponent.vue?vue&type=script&lang=js"
export * from "./ContestAdwardSectionComponent.vue?vue&type=script&lang=js"
import style0 from "./ContestAdwardSectionComponent.vue?vue&type=style&index=0&id=77fd3986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports